import React from 'react';
import cn from 'clsx';
import { SectionSubTitle } from '../../section-subtitle';
import { Header, Typography } from '../../typography';
import { stepContainer, stepName, stepNumber, stepNumberWrapper } from './step-styles';

export type StepStructure = {
  description: string;
  title: string;
};

type StepProps = {
  className?: string;
  number: number;
  shortStep?: boolean;
  variant?: Header;
} & StepStructure;

export const Step: React.FC<StepProps> = ({ className, description, number, variant = 'h3', title }) => (
  <div className={cn(stepContainer, className)}>
    <div className={stepNumberWrapper}>
      <span className={stepNumber}>{number}</span>
    </div>
    <div>
      <SectionSubTitle as="h3" className={stepName} margin="s" variant={variant}>
        {title}
      </SectionSubTitle>
      <Typography variant="m" size="body_long">
        {description}
      </Typography>
    </div>
  </div>
);
